import React, { useState } from 'react'
import "./header.css";


function Header() {
    /*============== toggle menu===========  */
    const[Toggle,showMenu] = useState(false);
    const [activeNav , setActiveNav] = useState("#home");
    const myStyle = {
        color: '#2d48d0',
      };
  return (
    <header className="header">
        <nav className="nav container">
            <a href="index.html" className="nav__logo">Shubham <i class='bx bxs-badge-check' style={myStyle}  ></i>  </a> 

            <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
                <ul className="nav__list grid">
                    <li className="nav__item">
                        <a href="#home" onClick={()=> setActiveNav("#home")} className={activeNav === "#home" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-estate nav__icon"></i> Home
                        </a>
                    </li>

                    <li className="nav__item">
                        <a href="#about"  onClick={()=> setActiveNav("#about")} className={activeNav === "#About" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-user nav__icon"></i> About
                        </a>
                    </li>

                    <li className="nav__item">
                        <a href="#skills" onClick={()=> setActiveNav("#skills")} className={activeNav === "#Skills" ? "nav__link active-link" : "nav__link"} >
                            <i className="uil uil-file-alt nav__icon"></i> Skills
                        </a>
                    </li>

                    <li className="nav__item">
                        <a href="#services" onClick={()=> setActiveNav("#services")} className={activeNav === "#Services" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-briefcase-alt nav__icon"></i> Services
                        </a>
                    </li>

                    <li className="nav__item">
                        <a href="#portfolio" onClick={()=> setActiveNav("#portfolio")} className={activeNav === "#Portfolio" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-scenery nav__icon"></i> Portfolio
                        </a>
                    </li>

                    <li className="nav__item">
                        <a href="#contact" onClick={()=> setActiveNav("#contact")} className={activeNav === "#Contact" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-message nav__icon"></i> Contact
                        </a>
                    </li>

                
                </ul>

                <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i>

            </div>

            <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
            <i className="uil uil-apps"></i>
            </div>
        </nav>
    </header>
  )
}

export default Header